import { render, staticRenderFns } from "./QualityDetail.vue?vue&type=template&id=3a1b0c76"
import script from "./QualityDetail.vue?vue&type=script&lang=js"
export * from "./QualityDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports